/* src/app/shared/skeleton/skeleton.component.scss */
:host {
  --skeleton-bg: rgba(75, 75, 75, 0.3);
}
.skeleton {
  background: var(--skeleton-bg);
  background-size: 200% 100%;
  border-radius: 4px;
  margin: 0.5rem 0;
  animation: pulse 1.3s infinite ease-in-out;
}
.skeleton.text {
  height: 16px;
  width: 80%;
}
.skeleton.card {
  border-radius: 8px;
}
.skeleton.card.xs {
  height: 120px;
  width: 8rem;
}
.skeleton.card.sm {
  height: 200px;
  width: 12rem;
}
.skeleton.card.md {
  height: 340px;
  width: 18rem;
}
.skeleton.card.lg {
  height: 480px;
  width: 24rem;
}
.skeleton.horizontal-card {
  border-radius: 8px;
  width: 100%;
}
.skeleton.horizontal-card.xs {
  height: 60px;
}
.skeleton.horizontal-card.sm {
  height: 100px;
}
.skeleton.horizontal-card.md {
  height: 170px;
}
.skeleton.horizontal-card.lg {
  height: 260px;
}
.skeleton.avatar {
  border-radius: 50%;
}
.skeleton.avatar.xs {
  width: 24px;
  height: 24px;
}
.skeleton.avatar.sm {
  width: 32px;
  height: 32px;
}
.skeleton.avatar.md {
  width: 40px;
  height: 40px;
}
.skeleton.avatar.lg {
  width: 56px;
  height: 56px;
}
.skeleton.table-row {
  height: 20px;
  width: 100%;
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.8;
  }
}
/*# sourceMappingURL=skeleton.component-5WE7QYXX.css.map */
